import type { FaireProductEntity } from "../../entity_types/product";

export const p_ey95wf4tzh: FaireProductEntity = {
  token: "p_ey95wf4tzh",
  type: "product",
  name: "Waho Blend Whole Bean Coffee",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl:
    "https://cdn.faire.com/fastly/a76d489b34b2295d6e14b44f2994939fefec53c4ca2185cbe0e6a9f186d0f27a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c19d5d0a24b494a4583a93cc24fdd64cde5715578ab58b70ac441faa9ff5bc83.jpeg",
    "https://cdn.faire.com/fastly/2da04d37b28429534a11845f7e93b7bae38bb3d35ddf826f0afcc6cbb0a0eb61.jpeg",
  ],
  priceDollars: 65,
  description:
    "• Size: 10oz Retail Tin, 2lb Bags, 5lb Bags\n• Taste Notes: Chocolate, Nutty, Perfectly pairs with waffles\n• Country: Mexico\n• Location: Chiapas\n• Elevation: 1300 MASL\n• Processing: washed\n\nOne of our favorite cups of coffee ever is one where you're sitting in a slightly uncomfortable booth surrounded by good people and even better food. You know the place.\nThis blend of Mexican coffees  provides an approachable cup for every coffee lover. ",
  tags: [],
  msrpDollars: 94.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:07.748Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
